/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App, type FeedPost } from "./App";

const elem = document.getElementById("root")!;
const createApp = (initialFeed?: FeedPost[]) => (
  <StrictMode>
    <App initialFeed={initialFeed} />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(createApp());
} else {
  const mount = async () => {
    // Generated pages already contain complete crawlable HTML. Keep it in place
    // until the data needed for the interactive version is available, and leave
    // it untouched if progressive enhancement fails.
    if (elem.hasChildNodes()) {
      try {
        const response = await fetch("/data/feed.json", { cache: "no-store" });
        if (!response.ok) {
          throw new Error(`Failed to fetch feed: ${response.status}`);
        }
        const feed = (await response.json()) as FeedPost[];
        createRoot(elem).render(createApp(feed));
      } catch (error) {
        console.warn("Interactive enhancement failed; keeping static page content.", error);
      }
      return;
    }

    // The development shell has no generated content and loads data inside App.
    createRoot(elem).render(createApp());
  };

  void mount();
}
